import './App.css';
import Hero from './Components/Hero/Hero';
import Horario from './Components/Horario/Horario';
// import Menu from './Components/Menu/Menu';
import NavbarTop from './Components/Navbartop/NavbarTop';
import Location from './Components/Location/Location';
import ContentfulMenu from './Components/ContentufulMenu/ContentfulMenu';

function App() {
  return (
    <div className="App">
      <NavbarTop />
      <Hero />
     <ContentfulMenu />
      {/* <Menu /> */}
      <Horario />
      <Location />
    </div>
  );
}

export default App;
